import {SPONSOR_STATISTIC_ACTIONS} from '../constants';

export const setStatistic = requestData => ({
  type: SPONSOR_STATISTIC_ACTIONS.SET_SPONSOR_STATISTIC,
  payload: {requestData},
});

export const setStatisticSuccess = () => ({
  type: SPONSOR_STATISTIC_ACTIONS.SET_SPONSOR_STATISTIC_SUCCESS,
});

export const setStatisticError = error => ({
  type: SPONSOR_STATISTIC_ACTIONS.SET_SPONSOR_STATISTIC_ERROR,
  payload: {error},
});
